<template>
  <plant-issues
    class="text-center"
    v-if="issue"
    :key="issue.key"
    :type="issue.type"
    :severity="issue.severity"
    :show-tooltip="true"
    :snoozed-until="issue.snoozed"
  />
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PlantJson } from '@/data/plants/PlantJson.ts';
import PlantIssues from '@/presentation/components/status/icon/PlantIssues.vue';

export default {
  name: 'NewIssueCell',
  components: { PlantIssues },
  props: {
    plantJson: {
      type: Object as PropType<PlantJson>,
      required: true,
    },
  },
  computed: {
    issue() {
      let newIssue = this.plantJson.issue;
      if (!newIssue) return;

      return {
        key: newIssue.id + newIssue.type_name,
        type: newIssue.type_name,
        severity: 'NOK',
        snoozed: newIssue.snoozed_until,
      };
    },
  },
};
</script>

<style scoped></style>
